module.exports = __webpack_public_path__ + "img/Agroalimentario2.f41dd4ab.jpg";